import { useState } from "react";
import { Plus, Check, X } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { TextInput } from "@/components/common/Forms";
import { api, errMsg } from "@/lib/api";

function Row({ kind, item, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(item.name);
  const patch = async (body) => {
    try {
      await api.patch(`/admin/lists/${kind}/${item.id}`, body);
      setEditing(false);
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid={`list-item-${item.id}`} className="flex items-center gap-4 py-3">
      {editing ? (
        <>
          <TextInput data-testid={`list-item-rename-input-${item.id}`} value={name} onChange={(e) => setName(e.target.value)} className="h-10" autoFocus />
          <button data-testid={`list-item-rename-save-${item.id}`} onClick={() => patch({ name })} aria-label="Salva"><Check className="w-4 h-4" /></button>
          <button onClick={() => { setEditing(false); setName(item.name); }} aria-label="Annulla"><X className="w-4 h-4" /></button>
        </>
      ) : (
        <>
          <span className={`flex-1 text-sm ${item.active ? "" : "text-warm-text line-through"}`}>{item.name}</span>
          <button data-testid={`list-item-rename-${item.id}`} onClick={() => setEditing(true)} className="btn-link text-xs">Rinomina</button>
          <label className="inline-flex items-center gap-2 text-xs text-warm-text w-24 justify-end">
            {item.active ? "Attiva" : "Disattiva"}
            <Switch data-testid={`list-item-active-${item.id}`} checked={item.active} onCheckedChange={(v) => patch({ active: v })} />
          </label>
        </>
      )}
    </div>
  );
}

export default function ListManager({ kind, items, onChanged, title, hint }) {
  const [name, setName] = useState("");
  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post(`/admin/lists/${kind}`, { name });
      setName("");
      onChanged();
      toast.success("Aggiunto");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <section className="lux-card p-6 sm:p-8" data-testid={`list-manager-${kind}`}>
      <h2 className="text-2xl font-normal">{title}</h2>
      {hint && <p className="text-sm text-warm-text mt-1">{hint}</p>}
      <div className="divide-y divide-warm/30 mt-4">
        {items.map((i) => <Row key={i.id} kind={kind} item={i} onChanged={onChanged} />)}
      </div>
      <form onSubmit={add} className="flex gap-3 mt-6">
        <TextInput data-testid={`list-add-input-${kind}`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Nuova voce" />
        <button data-testid={`list-add-btn-${kind}`} className="btn-ghost shrink-0"><Plus className="w-4 h-4" /> Aggiungi</button>
      </form>
    </section>
  );
}
